import { useMutation } from "urql";
import { graphql } from "../../../../__generated__/gql";
import Modal from "../../../../ui/Modal/Modal";
import { useCallback } from "react";
import ConfirmationModal from "../../../../ui/Modal/ConfirmationModal";
import { useToast } from "../../../../ui/Toast/ToastContext";

const DeletePatternMutation = graphql(/* GraphQL */ `
  mutation deletePattern($id: String!) {
    deletePattern(id: $id) {
      id
    }
  }
`);

function InnerDeletePatternModal({
  onClose,
  id,
  isOpen,
}: {
  onClose: () => void;
  id: string;
  isOpen: boolean;
}) {
  const { showToast } = useToast();
  const [{ fetching }, deletePattern] = useMutation(DeletePatternMutation);

  const onSubmit = useCallback(async () => {
    await deletePattern({
      id,
    });
    showToast({ title: "Pattern deleted" });
    onClose();
  }, [deletePattern, id, onClose, showToast]);

  return (
    <ConfirmationModal
      destructive
      loading={fetching || !isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      confirmationText="Delete"
    />
  );
}

function DeletePatternModal({
  isOpen,
  onClose,
  id,
}: {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Are you sure you want to delete this pattern?`}
    >
      <InnerDeletePatternModal onClose={onClose} id={id} isOpen={isOpen} />
    </Modal>
  );
}

export default DeletePatternModal;
